import Navbar from "@/components/HomeNavBar/HomeNavBar.vue"
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"
import CreateFeed from "@/components/CreateFeed/CreateFeed.vue"
import PortalRequest from "@/components/GetPortalRequest/PortalRequestView.vue"
import SurveyView from "@/components/SurveysAndPolls/Survey.vue";
import DocumentApproval from "@/components/DocumentApproval/DocumentApproval.vue";
import DocumentWarehouse from "@/components/DocumentWarehouse/DocumentWarehouse.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue"
import CreateTagCategory from "@/components/CreateTagCategory/CreateTagCategoryView.vue";
import ApprovalPublishingPost from "@/components/ApprovalPublishingPost/ApprovalPost.vue";
import ReportCommentModal from "@/components/ReportCommentModal/ReportCommentModal.vue";
import CreateSubject from "@/components/CreateSubject/CreateSubject.vue";
import AllSubjects from "@/components/GetSubjects/SubjectComponent.vue";
import { open_preview as open_file_preview } from "@/utils/file_preview";

import axios from "axios";

import {get_token , get_user_details } from "@/router";
import { client_domain } from "@/main.js";

/* global Masonry */

export default {
  components: {
    Navbar,
    AllPortals,
    CreateFeed,
    PortalRequest,
    SurveyView,
    DocumentApproval,
    DocumentWarehouse,
    StickyNav,
    CreateTagCategory,
    ApprovalPublishingPost,
    ReportCommentModal,
    CreateSubject,
    AllSubjects
  },
  data() {
    return {
      activeVoiceTab: 'your_feed',
      reports: [],
      expandedReports: [],
      current_date: new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(new Date()),
      token_exists: false,
      user_details: {
        "user_role": '',
        "user_id": null,
      },
      is_report_loading: false,
      hasLoadedOnce: false,
      categories: [],
      search_query: '',
      selectedFilters: new Map(),
      dwypd_domain: false,
      temporaryPost: null,
      validTagIds: [],
      comment_modal_visible: false,
      report_data: {},
      portal_admin: false,
      likedReports: JSON.parse(localStorage.getItem("likedReports") || "{}"),
      preloadedReports: [],
      page: 1,
      page_size: 4,
      hasMore: false,
      visible_domain:false,
      activeProfile:[],
    };
  },
  watch: {
    '$route.params.portal_id'() {
      this.filterReports();
    },
  },
  created() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.filterReports()
  },
  mounted() {
    this.$nextTick(() => this.loadMasonry());
    this.fetch_grouped_tags();

    if (client_domain.includes('dwypd') || client_domain.includes('soulcity') || client_domain.includes('nsp')) {
      this.dwypd_domain = true;
    }
    if(client_domain.includes('demo') || client_domain.includes('engagenet')){
        this.visible_domain = true;
      }
  },
  updated() {
    this.$nextTick(() => this.loadMasonry());
  },
  computed: {
filtered_reports() {
  // Convert the selectedFilters Map into an array of active tag IDs
  const activeTags = Array.from(this.selectedFilters.entries())
    .filter(([, selected]) => selected === true) // only true values
    .map(([id]) => String(id)); // ensure consistent string IDs


  return this.reports
    // 1. Only include reports visible to the current user
    .filter(report => this.is_visible_report(report))

    // 2. If there are active filters, check if **every selected filter** exists in the report's tags
    .filter(report => {
      // No active filters → include all reports
      if (activeTags.length === 0) return true;

      const reportTagIds = (report.tags || []).map(tag => String(tag.id));

      return activeTags.every(tagId => reportTagIds.includes(tagId));
    })
    // search articles
    .filter(report => {
      if (!this.search_query) return true;
      // Build a searchable string of everything relevant
      const searchable = [
        ...(report.tags || []).map(t => t.name),
        ...(report.tags || []).map(t => t.tag_category?.name),
        ...(report.authors || []).map(t => t.author_name),
        report.publication_date,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      let search_value = this.search_query
      return searchable.includes(search_value.toLowerCase());
    });
},


  allSelectedTags() {
    let tags = [];

    // Flatten Map → array
    this.selected_tags.forEach(arr => {
      tags.push(...arr);
    });

    // If there is a primary tag, move it to the front
    if (this.primary_tag) {
      const primaryId = this.primary_tag.id;

      tags = [
        // primary tag first
        {
          id: this.primary_tag.id,
          name: this.primary_tag.name
        },

        // all others except primary
        ...tags.filter(t => t.id !== primaryId)
      ];
    }

    return tags;
  },

  },
  methods: {
    onActiveProfileLoaded(profile) {
    this.activeProfile=profile},

 selectPrimaryTag(categoryId, tag) {
      //  Get old primary BEFORE modifying the map
      this.primary_tags.clear();
      const oldPrimary = this.primary_tags.get(categoryId) || null;

      // Update primary tag only for this category
      this.primary_tags.set(categoryId, tag || null);
      this.primary_tag = tag || null;

      // 3️⃣ Refresh secondary tags for THIS category
      let secondaryTags = this.selected_tags.get(categoryId) || [];

      // Remove the new primary from secondary
      if (tag) {
        secondaryTags = secondaryTags.filter(t => t.id !== tag.id);
      }

      // Remove the old primary from secondary
      if (oldPrimary) {
        secondaryTags = secondaryTags.filter(t => t.id !== oldPrimary.id);
      }

      this.selected_tags.set(categoryId, secondaryTags);

      this.primary_tags = new Map(this.primary_tags);
      this.selected_tags = new Map(this.selected_tags);
    }
,
    loadMasonry() {
      if (!this.$refs.masonryGrid) return;

      const msnry = new Masonry(this.$refs.masonryGrid, {
        itemSelector: ".masonry-item",
        percentPosition: true,
        gutter: 16,
      });
      setTimeout(() => {
       msnry.layout();
    }, 100);
  },
    hasTextContent(description) {
      if (!description) return false;

      const normalizedDescription = String(description).trim();
      if (!normalizedDescription || normalizedDescription === 'null' || normalizedDescription === 'undefined') {
        return false;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(normalizedDescription, 'text/html');
      const visibleText = (doc.body.textContent || '')
        .replace(/&nbsp;/g, ' ')
        .replace(/\u00a0/g, ' ')
        .replace(/\u200b/g, '')
        .trim();

      return visibleText.length > 0;
    },

  toggleTag(categoryKey, tagId) {
    const safeId = String(tagId);
    if (!this.validTagIds.includes(safeId)) return;

    const current = this.selectedFilters.get(safeId) === true;
    this.selectedFilters.set(safeId, !current);
  },
  likeReport(report) {
  if (!this.token_exists) {
    this.$router.push('/sign_in_finale');
    return;
  }
  const reportId = report.id;

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
    contentType: "application/json",
    headers: {
      'Authorization': `Token ${this.getToken()}`,
    },
    data: JSON.stringify({ report_id: reportId }),
    success: (response) => {
      if (response.status === "success") {
        const liked_report = this.reports.find(r => r.id === reportId);
        if (liked_report) {
          // ✅ increment both internal and displayed like count
          liked_report.like_count++;
          liked_report.total_likes = (liked_report.total_likes || 0) + 1;

          // ✅ Replace reports array for reactivity (if needed)
          this.reports = [...this.reports];
        }

        if (
          (typeof reportId === 'number' && Number.isInteger(reportId)) ||
          (typeof reportId === 'string' && /^[a-zA-Z0-9_-]+$/.test(reportId))
        ) {
          Reflect.set(this.likedReports, reportId, true);
          localStorage.setItem("likedReports", JSON.stringify(this.likedReports));
        } else {
          console.warn('Invalid reportId:', reportId);
        }
      }
    }
  });
},

 updateLikeCounts(reportId) {
    const report = this.reports.find(r => r.id === reportId);
    if (!report) return;

    if (report.like_count > 0) report.like_count--;
    if (report.total_likes > 0) report.total_likes--;
  },
unlikeReport(report) {
  if (!this.token_exists) {
    this.$router.push('/sign_in_finale');
    return;
  }

  const reportId = report.id;

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
    contentType: "application/json",
    headers: {
      'Authorization': `Token ${this.getToken()}`,
    },
    data: JSON.stringify({ report_id: reportId }),
    success: (response) => {
      if (response.status === "success") {
        this.updateLikeCounts(reportId);

        // Validate reportId before setting
        if (
          (typeof reportId === 'number' && Number.isInteger(reportId)) ||
          (typeof reportId === 'string' && /^[a-zA-Z0-9_-]+$/.test(reportId))
        ) {
          Reflect.set(this.likedReports, reportId, false);
          localStorage.setItem("likedReports", JSON.stringify(this.likedReports));
        } else {
          console.warn('Invalid reportId:', reportId);
        }
      }
    }
  });
},

  isTagSelected(tagId) {
    const safeId = String(tagId);
    if (!this.validTagIds.includes(safeId)) return false;

    return this.selectedFilters.get(safeId) === true;
  },
  hide_comment_comment() {
  this.report_data = {};
  this.comment_modal_visible = false;
},
    addTemporaryPost(post) {
      this.temporaryPost = post;
    },


  filteredCategoriesForReport(report) {
  const mergedTags = [...(report.tags || [])];
  if (report.primary_tag) mergedTags.unshift(report.primary_tag); // primary first

  const categories = [];

  mergedTags.forEach(tag => {
    const catName = tag.tag_category?.name || 'Uncategorized';

    // Check if category already exists
    let category = categories.find(c => c.name === catName);
    if (!category) {
      category = { name: catName, tags: [] };
      categories.push(category);
    }

    category.tags.push(tag);
  });

  return categories;
},

    closeMenu(reportId) {
      const checkbox = document.getElementById('menu-open-' + reportId);
      if (checkbox) {
        checkbox.checked = false;
      }
    },
   baseUrl(post, type) {
      const baseUrl = `${window.location.origin}${this.$route.path}`;

      // Dynamically build the URL based on the type (either 'hub' or 'report')
      if (type === 'report') {
        return `${baseUrl}?report_id=${post.id}`;
      }
      return baseUrl
    },
    clearTagFilter() {
    const query = { ...this.$route.query };
    delete query.tag_id;
    delete query.tag_name;

    this.$router.push({
      name: 'publish_portal',
      params: {
        portal_id: this.$route.params.portal_id,
        portal_name: this.$route.params.portal_name,
      },
      query,
    });
  },
  display_comment_modal(data) {
  this.report_data = data;
  this.comment_modal_visible = true;
},
  open_preview(document) {
    open_file_preview(this, document);
  },


    fetch_grouped_tags() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
        method: 'GET',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: response => {
          if (response.status === 'success') {
            const tag_list = response.data.tags;

            // ✅ store allowed tag ids for validation
            this.validTagIds = tag_list.map(tag => String(tag.id));
            const grouped = new Map();

            tag_list.forEach(tag => {
              const categoryName = tag.tag_category.name;
              const categoryId = tag.tag_category.id;

              if (!grouped.has(categoryName)) {
                grouped.set(categoryName, {
                  id: categoryId,
                  tags: []
                });
              }

              grouped.get(categoryName).tags.unshift({
                id: tag.id,
                name: tag.name
              });
            });

            this.categories = Array.from(grouped.entries()).map(
              ([name, { id, tags }]) => ({
                key: name.toLowerCase().replace(/\s+/g, '-'),
                id, // ✅ category id included here
                name,
                tags
              })
            );

          }
        }
      });
    },

    handleScroll() {
    const container = this.$refs.scrollContainer;
  if (!container) return;

    const scrollBottom = container.scrollTop + container.clientHeight;
  if (scrollBottom >= container.scrollHeight - 50) { // near bottom
    this.filterReports();
  }
  },

    is_approved_report(report) {
  const status = report?.status;
  const statusName = typeof status === 'string' ? status : status?.name;

  return String(statusName || '').toLowerCase() === 'approved';
},
    can_manage_report(report) {
  const is_admin = this.user_details?.user_role === 'admin';
  const is_creator = String(report?.base_profile?.user?.id) === String(this.user_details?.user_id);

  return is_admin || (is_creator && this.token_exists);
},
    is_visible_report(report) {
  if (!report || !this.user_details) {
    return false;
  }

  const is_admin = this.user_details.user_role === 'admin';
  const is_creator = String(report.base_profile?.user?.id) === String(this.user_details.user_id);
  const is_approved = this.is_approved_report(report);

  // Only admins, creators, or approved reports are visible
  return is_admin || is_creator || is_approved;
},
    getToken() {
      return get_token();
    },
    processPortalReports(results) {


  // Prevent duplicates if needed
  const newReports = results.filter(r => !this.reports.some(existing => existing.id === r.id));
  this.reports.push(...newReports);
  newReports.forEach((report) => {
    if (report.report_link && !report.linkPreview) {
      this.fetchReportPreview(report);
    }
  });
},

    fetchReportPreview(report) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
        type: 'POST',
        data: { url: report.report_link },
        headers: { Authorization: `Token ${get_token()}` },
        success: (data) => {
          report.linkPreview = data;
        },
      });
    },

async filterReports() {
  if (this.is_report_loading) return;

  this.is_report_loading = true;
  const portal_id = this.$route.params.portal_id;
  const report_id = this.$route.query.report_id;
  const headersConfig = {
    headers: {
      Authorization: `Token ${this.getToken()}`,
      'Content-Type': 'application/json',
    },
  };

  try {
    let results;

    // 1️⃣ Use preloaded reports if available
    if (this.preloadedReports.length) {
      results = this.preloadedReports;
      this.preloadedReports = [];
      this.page += 1;
    } else {
      // 2️⃣ Normal fetch
      const res = await axios.post(
        `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_portal/`,
        { portal_id, page: this.page, page_size: this.page_size },
        headersConfig
      );

      if (res.data.status === 'success' && res.data.report_data) {
        results = res.data.report_data.results || [];
        this.hasMore = res.data.report_data.has_more;
        this.page = res.data.report_data.page + 1;
      }
    }

    // 3️⃣ Process the results
    if (results.length) this.processPortalReports(results);

    // 4️⃣ Preload next page in background
    if (this.hasMore) this.preloadPortalReports(portal_id);

    // 5️⃣ Open modal if report_id is passed
    if (report_id) {
      const selectedReport = this.reports.find(r => r.id == report_id);
      if (selectedReport) {
        this.display_comment_modal(selectedReport);
      }
    }

  } catch (error) {
    console.error('Error fetching reports:', error.response?.data || error.message);
  } finally {
    this.is_report_loading = false;
    this.hasLoadedOnce = true;
  }
},

async preloadPortalReports(portal_id) {
  const headersConfig = {
    headers: {
      Authorization: `Token ${this.getToken()}`,
      'Content-Type': 'application/json',
    },
  };
  try {
    const res = await axios.post(
      `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_portal/`,
      { portal_id, page: this.page, page_size: this.page_size },
      headersConfig
    );

    if (res.data.status === 'success' && res.data.report_data) {
      this.preloadedReports = res.data.report_data.results || [];
      this.hasMore = res.data.report_data.has_more;
    }
  } catch (error) {
    console.error('Error preloading reports:', error.response?.data || error.message);
    this.preloadedReports = [];
  }
},


      get_description(report) {
        if (!report.description) return '';

        // Use DOMParser to safely parse HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(report.description, 'text/html');

        // Remove all <img> tags
        doc.querySelectorAll('img').forEach(img => img.remove());

        const textOnly = doc.body.textContent.trim();

        if (this.expandedReports.includes(report.id) || textOnly.length <= 250) {
          return textOnly;
        }

        return textOnly.substring(0, 250) + '...';
      },

    delete_report(report_id) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "DELETE",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_api/`,
            data: JSON.stringify({ report_id: report_id }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.reports = this.reports.filter(report => report.id !== report_id);
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The feed has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                })
              } else {
                Swal.fire({
                  title: 'Failed!',
                  text: response.message || 'An error occurred. Please try again.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            },
            error: () => {
              Swal.fire({
                title: 'Failed!',
                text: 'An error occurred. Please try again.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },

    add_report(newReport) {
      if (newReport) {
        if (newReport) {
          this.reports.unshift(newReport);
        }
      }
      this.temporaryPost = null;
    },
    open_create_feed_edit(report) {
      const createFeed = this.$refs.createFeed;
      if (!createFeed?.open_edit_report) return;

      createFeed.open_edit_report(report);
    },
    update_report(updatedReport) {
      if (!updatedReport?.id) return;

      const reportIndex = this.reports.findIndex(
        (report) => String(report.id) === String(updatedReport.id)
      );

      if (reportIndex !== -1) {
        const currentReport = this.reports.slice(reportIndex, reportIndex + 1).shift();
        this.reports.splice(reportIndex, 1, {
          ...currentReport,
          ...updatedReport,
        });
      }
    },

    getFileIcon(fileUrl) {
      const iconMap = [
        { extensions: ['.pdf'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337946.png' },
        { extensions: ['.doc', '.docx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337932.png' },
        { extensions: ['.xls', '.xlsx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337958.png' },
        { extensions: ['.ppt', '.pptx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337950.png' },
        { extensions: ['.html', '.htm'], icon: 'https://cdn-icons-png.flaticon.com/128/732/732212.png' },
      ];

      for (const { extensions, icon } of iconMap) {
        if (extensions.some(ext => fileUrl.includes(ext))) {
          return icon;
        }
      }

      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
    }
    ,
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },
    copyReportLinkToClipboard(report) {
    const link = this.baseUrl(report, 'report');
    navigator.clipboard.writeText(link).then(() => {
      this.showToast('Link copied to clipboard!');
    })
    },
    showToast(message) {
    document.querySelector('#copyToast .toast-body').textContent = message;

    $('#copyToast').fadeIn(300).addClass('show');
    setTimeout(function() {
      $('#copyToast').fadeOut(30).removeClass('show');
      }, 3000);
    },
     get_report_images(report) {
      const imageExtensions = [ '.jpg', '.jpeg', '.png', '.avif', '.webp']

      return report.report_files
          .filter(fileObj => {
              const url = fileObj?.file?.url
              if (!url) return false
              if (url.startsWith('data:image')) return true
              const lowerUrl = url.toLowerCase()
              return imageExtensions.some(ext => lowerUrl.includes(ext))
          })
          .map(fileObj => fileObj.file.url)
    },
  filtered_files(files) {
    if (!files) return []

    return files.filter(fileObj => {
      const url = fileObj?.file?.url || ''

      return !(
        url.includes('.jpg') ||
        url.includes('.JPG') ||
        url.includes('.jpeg') ||
        url.includes('.JPEG') ||
        url.includes('.png') ||
        url.includes('.PNG') ||
        url.includes('.webp') ||
        url.includes('.WEBP') ||
        url.includes('.avif') ||
        url.includes('.AVIF') ||
        url.startsWith('data:image')
      )
    })
},

  }
  }
